import { Route } from "@/interfaces/Routes";

export const AuthRoutes: Route = {
  IS_AUTHENTICATED: "/user",
  LOGOUT: "/logout",
  LOGIN: "/login",
};
